module.exports = __webpack_public_path__ + "img/智慧应急.bf8d71bb.png";